export enum SonoraEntityType {
    File = 0,
    StickyNotes = 1,
    MeetingTimes = 2,
}

export default interface SonoraItem {
    type: SonoraEntityType;
}
